import { StockOperationsService } from "core/service";
import { StockOperationsPersistence } from "core/persistence";
import {
  RuntimeRepository,
  ProductRepository,
  UserRepository
} from "core/repository";
import BaseRepository from "./base.repository";
import { StockOperation } from "core/entity";
import Papa from "papaparse";
import Moment from "moment";
import Big from "big.js";

class StockOperationsRepository extends BaseRepository {
  syncable = false;

  getEntityIdentifier() {
    return "stockOperations";
  }

  resourceName() {
    return "estoque";
  }

  getPersistenceProvider() {
    return StockOperationsPersistence;
  }

  getServiceProvider() {
    return StockOperationsService;
  }

  async modelToEntity(model) {
    const entity = new StockOperation(model);
    const userOperatorResult = await UserRepository.get(model.user_uuid);
    if (userOperatorResult.success) {
      entity.user_operator = userOperatorResult.data;
    }

    const productNameResults = await ProductRepository.get(model.sellable_uuid);
    if (productNameResults.success) {
      entity.product_name = productNameResults.data;
    }

    if (entity.amount) {
      let amount = Big(entity.amount);
      entity.amount = amount.toString();
    }

    return entity;
  }

  async getOperations({
    order = [],
    pagination = {},
    filters = [],
    transforms = []
  }) {
    const currentUser = await this.mRuntime.get(
      RuntimeRepository.props.currentUser
    );
    const serviceResult = await this.mService.fetch(currentUser.company_uuid, {
      order,
      pagination,
      filters,
      transforms
    });

    if (serviceResult.success) {
      return {
        success: true,
        data: serviceResult.data,
        total: serviceResult.headers["total"],
        perPage: serviceResult.headers["per-page"]
      };
    }

    return {
      success: false,
      fatal: serviceResult.fatal,
      errors: serviceResult.errors
    };
  }

  async getReportCsvContent({ order, filters }, header, callback) {
    const data = [];
    const currentUser = await this.mRuntime.get("currentUser");
    const listResult = await this.mService.stream(
      currentUser.company_uuid,
      { order, filters },
      async stock => {
        data.push(await callback(stock));
      }
    );

    if (!listResult) {
      return { success: false };
    }

    const content = Papa.unparse({ fields: header, data });

    return { success: true, data: content };
  }

  async _stockToReportCsvLine(model) {
    const stock = await this.modelToEntity(model);
    const userRepositoryResults = await UserRepository.get(stock.user_uuid);
    const productRepositoryResults = await ProductRepository.get(
      stock.sellable_uuid
    );

    if (userRepositoryResults.success && productRepositoryResults.success) {
      return [
        Moment(stock.created_at).format("DD/MM/YYYY HH:mm:ss"),
        productRepositoryResults.data.name,
        stock.activity,
        stock.amount,
        stock.cost_value,
        userRepositoryResults.data.name
      ];
    }
  }

  async graph(productUuid, dateFrom, dateTo, interval) {
    return await this.mService.graph(productUuid, dateFrom, dateTo, interval);
  }
}

export default new StockOperationsRepository();



// WEBPACK FOOTER //
// ./src/core/repository/stock-operations.repository.js